import QRCode from 'qrcode';

import I18n from '@utils/i18n';

export const createQRCode = (text, style = {}) => {
  return new Promise((resolve) => {
    QRCode.toDataURL(text, { margin: 0, width: 77, height: 77, ...style }, (err, url) => {
      resolve(url)
    })
  })
}

export const createImg = (imgUrl) => {
  const img = new Image();
  img.setAttribute('crossOrigin', 'Anonymous');
  img.src = imgUrl;
  return new Promise((resolve) => {
    img.onload = () => {
      resolve(img);
    }
  })
}

const getOffsetXY = (ctx, text, canvasWidth) => {
  const textObj = ctx.measureText(text)
  const width = textObj.width;
  const ml = Math.floor((canvasWidth - width) / 2)
  return ml
}
/**
   * text         文本
   * x,y          轴
   * width        行宽
   * fontSize     字体大小
   * rouHeight    行高，如果字体16px，1.5倍行距应该是24px
   * ctx          画板内容对象
*/
const drawText = ({ text, x, y, width, fontSize, lineHeight, fillStyle, ctx }) => {
  // 1 将字符串转换成数组
  const test = text.split('')
  let temp = ''
  const row = []
  // 1.1 设置样式
  ctx.font = `${fontSize}px DINPro`
  ctx.fillStyle = fillStyle;
  ctx.textBaseline = 'middle'
  // 1.2 计算文字宽度，若文字宽度大于设定的宽度，则push到数组下一个元素，否则将字符串++
  for (let i = 0; i < test.length; i++) {
    if (ctx.measureText(temp).width > width) {
      row.push(temp)
      temp = ''
    }
    temp += test[i]
  }
  // 1.3 循环结束将temp最后一段字符push
  row.push(temp)
  // 1.4 遍历数组,输出文字
  for (let j = 0; j < row.length; j++) {
    ctx.fillText(row[j], x, y + (j + 1) * fontSize * lineHeight)
  }
}

export const drawInvite = ({ qrcodeImg, bgImg, code, kikiLogo }) => {
  const canvas = document.createElement('canvas');
  canvas.width = 530;
  canvas.height = 732;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(bgImg, 0, 0, 530, 732);
  const title = I18n.t('nIVuFHoJ');
  const subTitle = I18n.t('gx5yay08');
  ctx.font = '40px DINPro';
  ctx.fillStyle = '#6F40EE';
  ctx.fillText(title, 32, 64);
  drawText({
    text: subTitle,
    width: 408,
    x: 32,
    y: 72,
    fontSize: 24,
    fillStyle: '#6F40EE',
    lineHeight: 1.5,
    ctx
  })
  ctx.drawImage(kikiLogo, 32, 620, 152, 28);
  drawRoundedRect({ // 绘制邀请码背景
    ctx,
    x: 32,
    y: 665,
    width: 340,
    height: 40,
    radius: 4
  });
  ctx.fillStyle = '#6F40EE';
  ctx.fill();
  ctx.restore();
  ctx.font = '24px DINPro';
  ctx.fillStyle = '#FFFFFF';
  const text = I18n.t('sGG26kmQ') + ` ${code}`;
  ctx.fillText(text, getOffsetXY(ctx, text, 408), 688);
  drawRoundedRect({ // 绘制二维码背景
    ctx,
    x: 404,
    y: 618,
    width: 100,
    height: 100,
    radius: 8
  });
  ctx.fillStyle = 'rgba(111,64,238,.08)';
  ctx.fill();
  ctx.restore();
  ctx.drawImage(qrcodeImg, 410, 624, 88, 88);
  const res = canvas.toDataURL('image/png')
  return { url: res, canvas };
}

export const downImg = (url) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = 'poster.png'
  const event = new MouseEvent('click');
  a.dispatchEvent(event);
}

// 生成有圆角的矩形
const drawRoundedRect = ({ ctx, x, y, width, height, radius }) => {
  ctx.beginPath();
  ctx.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 3 / 2);
  ctx.lineTo(width - radius + x, y);
  ctx.arc(width - radius + x, radius + y, radius, Math.PI * 3 / 2, Math.PI * 2);
  ctx.lineTo(width + x, height + y - radius);
  ctx.arc(width - radius + x, height - radius + y, radius, 0, Math.PI * 1 / 2);
  ctx.lineTo(radius + x, height + y);
  ctx.arc(radius + x, height - radius + y, radius, Math.PI * 1 / 2, Math.PI);
  ctx.closePath();
}

export const drawAirdrop = ({ qrcodeImg, title, kikiLogo, boxImg, subTitle }) => {
  const canvasWidth = 650;
  const canvas = document.createElement('canvas');
  canvas.width = canvasWidth;
  canvas.height = 840;
  const ctx = canvas.getContext('2d');
  // 绘制圆角矩形
  drawRoundedRect({
    ctx,
    x: 0,
    y: 0,
    width: canvasWidth,
    height: canvas.height,
    radius: 36
  });
  // 画布裁切
  ctx.clip()
  ctx.fillStyle = '#191A22';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(boxImg, 121, 72, 408, 380);
  ctx.drawImage(qrcodeImg, 265, 625, 120, 120);
  ctx.drawImage(kikiLogo, 245, 762, 160, 30);
  ctx.font = '40px DINPro'
  ctx.fillStyle = '#fff'
  ctx.fillText(title, getOffsetXY(ctx, title, canvasWidth), 422)
  ctx.font = '24px DINPro'
  ctx.fillStyle = 'rgba(255, 255, 255, 0.4)'
  ctx.fillText(subTitle, getOffsetXY(ctx, subTitle, canvasWidth), 494)
  const res = canvas.toDataURL('image/png')
  return { url: res, canvas };
}
